import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import About from "../pages/about/page";
import Journal from "../pages/journal/page";
import Challenge from "../pages/challenge/page";
import Contact from "../pages/contact/page";
import Tracker from "../pages/tracker/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/shop", element: <Shop /> },
  { path: "/about", element: <About /> },
  { path: "/journal", element: <Journal /> },
  { path: "/challenge", element: <Challenge /> },
  { path: "/contact", element: <Contact /> },
  { path: "/tracker", element: <Tracker /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
